<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸比对</h1>
		<!--  人脸特征比对，字符串类型特征-->
		<h2 class="doc_main_h2">人脸特征比对，字符串类型特征</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (float)skFaceFeatureCompare:(NSString *)faceFeaA_Base64 faceFeaB_Base64:(NSString *)faceFeaB_Base64;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）faceFeaA_Base64：第一个人脸的特征字符串</p>
        <p class="doc_main_p">（2）faceFeaB_Base64：第二个人脸的特征字符串</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	float类型数据，范围[0-1]，值越大表示相似度越高。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">NSString *feaA = "TOgywJ………wuT/vmIDKkA=";// 数据较长，此处仅作示意
NSString *feaB = "KtFEA…………+vkk6JUA=";// 数据较长，此处仅作示意
float compareRes = [SKFaceManagerInterface skFaceFeatureCompare:feaA faceFeaB_Base64:feaB];
</code></pre>
		<!--  人脸特征比对，unsigned char[] 类型特征-->
		<h2 class="doc_main_h2">人脸特征比对，unsigned char[] 类型特征</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (float)skFaceFeaturepCompare:(unsigned char[])faceFeaA faceFeaB:(unsigned char[])faceFeaB;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）faceFeaA：第一个人脸的特征unsigned char[521 * sizeof(float)]类型</p>
        <p class="doc_main_p">（2）faceFeaB_Base64：第二个人脸的特征unsigned char[521 * sizeof(float)]类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	float类型数据，范围[0-1]，值越大表示相似度越高。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// pa第一个人脸特征、pb第二个人脸特征，
//图片检测回调数据的结构体里直接获得(unsigned char feature[512 * sizeof(float)])
CGFloat result = [SKFaceManagerInterface skFaceFeaturepCompare:pa faceFeaB:pb];
</code></pre>
		<!--  人脸特征unsigned char[512 * sizeof(float)]转base64字符串 -->
		<h2 class="doc_main_h2">人脸特征unsigned char[512 * sizeof(float)]转base64字符串</h2>
		<!-- <h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p> -->
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (NSString *)skFaceFeaturepToBase64:(unsigned char[])featurep;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">featurep：要转换的人脸特征unsigned char[521 * sizeof(float)]类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	人脸特征Base64字符串类型
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">NSString * feature = [SKFaceManagerInterface skFaceFeaturepToBase64:faceStruct[i].feature];</code></pre>
		<!--  人脸特征base64字符串转unsigned char[512 * sizeof(float)] -->
		<h2 class="doc_main_h2">人脸特征base64字符串转unsigned char[512 * sizeof(float)]</h2>
		<!-- <h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行两个人脸的1：1特征比对，得出比分。
		</p> -->
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (void)skFaceBase64ToFeaturep:(NSString *)base64str featurep:(unsigned char[])featurep;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）base64str: 要转换的人脸特征Base64字符串格式</p>
        <p class="doc_main_p">（2）featurep：转换后的人脸特征unsigned char[521 * sizeof(float)]类型</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	无
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">unsigned char pa [512 * sizeof(float)];
[SKFaceManagerInterface skFaceBase64ToFeaturep:base64str
featurep:featurep];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','图片接口','人脸比对'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/image/faceContrast.vue